// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-dialog-content {
  min-width: 700px;
  padding: 2px 24px !important;
  background-color: #f0f0f0;
}

.content {
  padding: 16px;
  border-radius: 4px;
}

mat-dialog-actions {
  background-color: #f0f0f0;
  padding: 8px 24px !important;
}

.button-gap { gap: 12px; }

.btn::after { content: '' !important; display: none !important; }

.notes-cell {
  max-width: 400px;
  white-space: pre-wrap;
  word-break: break-word;
}

textarea.form-control {
  resize: vertical;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/tools/notes-notification/notes-notification.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA,cAAc,SAAS,EAAE;;AAEzB,cAAc,sBAAsB,EAAE,wBAAwB,EAAE;;AAEhE;EACE,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["mat-dialog-content {\n  min-width: 700px;\n  padding: 2px 24px !important;\n  background-color: #f0f0f0;\n}\n\n.content {\n  padding: 16px;\n  border-radius: 4px;\n}\n\nmat-dialog-actions {\n  background-color: #f0f0f0;\n  padding: 8px 24px !important;\n}\n\n.button-gap { gap: 12px; }\n\n.btn::after { content: '' !important; display: none !important; }\n\n.notes-cell {\n  max-width: 400px;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\ntextarea.form-control {\n  resize: vertical;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
